import { FC, useMemo } from 'react'
// import styles from 'components/features/pfm/NewBadge/NewBadge.styl'
import { isServiceInsight } from 'helpers/insightHelpers'
import Badge from 'components/features/insights/Insight/Badge'
import { RawSocialInnerInsight } from 'interfaces/socialInsights'

type NewBadgeProps = {
  insight: RawSocialInnerInsight
}

export const NewBadge: FC<NewBadgeProps> = (props) => {
  const { insight } = props
  const { is_new, is_dismissed } = insight

  return useMemo(() => {
    if (isServiceInsight(insight)) {
      return null
    }
    if (!is_new || is_dismissed) {
      return null
    }

    return (
      <Badge theme='fresh' size='small'>
        New
      </Badge>
    )
  }, [is_new, is_dismissed, insight])
}
